import Vue from 'vue';
import VueFilter from 'vue-filter';
import ElementUI from 'element-ui';
import VueGtag from 'vue-gtag';
import money from 'v-money';
import Trend from 'vuetrend';
import Mime from 'mime';
import Hotjar from 'vue-hotjar';
import Sentry from '@/plugins/Sentry';
import MyTracker from '@/plugins/MyTracker';
import router from '@/router';
import store from '@/store';
import { errorHandler, sso } from '@/util';
import App from './App';

ElementUI.Select.computed.readonly = (vueComp) => {
  const isIE = !vueComp.$isServer && !Number.isNaN(Number(document.documentMode));

  return !(vueComp.filterable || vueComp.multiple || !isIE) && !vueComp.visible;
};

import(/* webpackPrefetch: true */ '@/styles/index.scss'); // eslint-disable-line no-unused-expressions

/* global __webpack_nonce__ */ // eslint-disable-line no-unused-vars
__webpack_nonce__ = Date.now(); // eslint-disable-line no-global-assign, camelcase

Vue.use(MyTracker, { router });
Vue.use(Mime);
Vue.use(Trend);
Vue.use(money);
Vue.use(VueFilter);
Vue.config.productionTip = false;
Vue.use(ElementUI, { size: 'mini' });
Vue.use(VueGtag, {
  config: {
    id: 'UA-137748533-1',
    disableScriptLoad: false,
    pageTrackerScreenviewEnabled: true,
  },
  includes: [],
}, router);
Vue.use(Sentry, router);

if (process.env.NODE_ENV === 'production') {
  Vue.use(Hotjar, {
    id: '3209991', // Hotjar Site ID
  });
}

Vue.config.errorHandler = errorHandler;

// Begin loading sso, no need to stop execution since we won't load data from there
sso();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});
